export default "__VITE_ASSET__CGx3SrEI__"